import { prop } from 'lodash/fp'

import { useCoreStore } from '@/shared/lib/core-store'

export function useOptimizationGroupId() {
	return useCoreStore(prop('optimizationGroupId')) as string | undefined
}
